import Utils from '../../Utils';
import AnchorLinks from "./AnchorLinks";

export default class Summary {

    static initializeEvents() {
        const h1 = document.querySelector('h1');
        const isHomepage = h1 && h1.innerText.includes('L\'information') && h1.innerText.includes('pour l\'orientation');

        // Sauf sur la page d'accueil, un sommaire automatique est construit à partir des titres H2 dans les pages libres
        if (!isHomepage) {
            const landingPageSummary = document.getElementById('landing-page-summary');
            if (landingPageSummary) {
                const summary = landingPageSummary.querySelector('.summary-list');
                const summaryTitles = document.querySelectorAll('.landing-page-blocks .landing-page-block h2');

                if (summaryTitles.length) {
                    summary.innerHTML = Array
                        .from(document.querySelectorAll('.landing-page-blocks .landing-page-block h2'))
                        .map(title => {
                            const block = Utils.parent(title, '.landing-page-block');

                            return `<li><a href="#${block.id}">${title.innerText}</a></li>`;
                        })
                        .join('');

                    landingPageSummary.removeAttribute('aria-hidden');

                    // Lors du scroll, le bloc affiché à l'écran est marqué comme "actif" dans le sommaire
                    window.addEventListener('scroll', Utils.throttle(() => {
                        Array
                            .from(document.querySelectorAll('.landing-page-blocks .landing-page-block h2'))
                            .map(title => {
                                const block = Utils.parent(title, '.landing-page-block');
                                const positionStart = Utils.getOffsetTop(block) - 80;
                                const positionEnd = Utils.getOffsetTop(block) + block.offsetHeight;

                                const activeSummaryLink = summary.querySelector('a[href="#' + block.id + '"]');
                                if (window.scrollY >= positionStart && window.scrollY < positionEnd) {
                                    if (!activeSummaryLink.classList.contains('active')) {
                                        const currentActiveSummaryLink = summary.querySelector('a.active');
                                        if (currentActiveSummaryLink) {
                                            currentActiveSummaryLink.classList.remove('active');
                                        }

                                        activeSummaryLink.classList.add('active');
                                    }
                                }
                            });
                    }, 75));
                } else {
                    const leftZoneColumn = landingPageSummary.parentNode;
                    const mainZoneColumn = leftZoneColumn.nextElementSibling;

                    if (leftZoneColumn.classList.contains('grid-col-xl-3') && mainZoneColumn.classList.contains('grid-col-xl-5')) {
                        mainZoneColumn.classList.replace('grid-col-xl-5', 'grid-col-xl-8');
                        leftZoneColumn.parentNode.removeChild(leftZoneColumn);
                    }
                }
            }
        }

        // Lors du clic sur le lien d'un sommaire avec une ancre et que la cible de l'ancre n'existe pas
        Array
            .from(document.querySelectorAll('.summary .summary-list li a[href^="#"]'))
            .forEach(summaryLink => {
                summaryLink.addEventListener('click', event => {
                    const summaryLinkTargetId = event.currentTarget.getAttribute('href');
                    const summaryLinkTargetElement = document.getElementById(summaryLinkTargetId.substring(1));

                    if (!summaryLinkTargetElement) {
                        const summaryLinkTargetElementSearch = Array
                            .from(document.querySelectorAll('h1,h2,h3,h4'))
                            .filter(el => el.innerText.trim().includes(event.currentTarget.innerText.trim()));

                        if (summaryLinkTargetElementSearch[0] !== undefined) {
                            const focusOutHandler = event => {
                                event.target.removeAttribute('tabindex');
                                event.target.removeEventListener('focusout', focusOutHandler);
                            };

                            summaryLinkTargetElementSearch[0].setAttribute('tabindex', '0');
                            summaryLinkTargetElementSearch[0].addEventListener('focusout', focusOutHandler);
                            summaryLinkTargetElementSearch[0].scrollIntoView({behavior: 'smooth'});
                            summaryLinkTargetElementSearch[0].focus();
                        }
                    } else {
                        const summaryLinkTargetUrl = window.location.origin + window.location.pathname + summaryLinkTargetId;
                        AnchorLinks.adjustScrollForAnchor(new URL(summaryLinkTargetUrl), event);
                    }
                });
            });
    }

}